import React, { Fragment } from "react";
import { Breadcrumbs, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import MaterialTable from "../../../components/material_table";

function Page(props) {
	const {
		responsables,
		handle_export,
	} = props;

	const history = useHistory();

	let columns = [
		{
			title: "Nombre",
			field: "persona.nombre_completo",
		}, {
			title: "RUN",
			field: "persona.run",
		}, {
			title: "Correlativo",
			field: "correlativo",
		},
	];

	let actions = [
		{
			icon: "edit",
			tooltip: "Editar",
			onClick: (event, row) => history.push(`/responsable/${row._id}`),
			iconProps: { style: { color: "#757575" } },
			hidden: false, //Verificar permisos
			disabled: false, //Verificar permisos
		}, {
			icon: "delete",
			tooltip: "Eliminar",
			onClick: (event, row) => alert("Eliminar Contrato"),
			iconProps: { style: { color: "#757575" } },
			hidden: true, //Verificar permisos
			disabled: false, //Verificar permisos
		}, {
			icon: "add",
			tooltip: "Agregar",
			onClick: () => history.push("/responsable"),
			isFreeAction: true,
			hidden: false, //Verificar permisos
			disabled: false, //Verificar permisos
		},
	];

	return (
		<Fragment>
			<Breadcrumbs separator=">">
				<Typography color="textPrimary">Módulo Responsables</Typography>
				<Typography color="textPrimary">Listado Responsables</Typography>
			</Breadcrumbs>
			<MaterialTable
				title="Listado de Responsables"
				is_loading={!responsables}
				columns={columns}
				data={responsables}
				actions={actions}
				export_function={handle_export}
			/>
		</Fragment>
	);
}

export default Page;